import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'ContentType';

  static fields = {
    id: attr(),
    key: attr(),
    title: attr(),
    icon: attr(),
    sort: attr(),
    isHidden: attr(),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'contentTypes',
    }),
  };

  static reducer({ type, payload }, ContentType) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        ContentType.all().delete();
        if (payload.contentTypes) {
          payload.contentTypes.forEach((item) => {
            ContentType.upsert(item);
          });
        }
        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.contentTypes) {
          payload.contentTypes.forEach((item) => {
            ContentType.upsert(item);
          });
        }
        break;
      case ActionTypes.CONTENT_TYPES_FETCH__SUCCESS: {
        const targetPointSystemId = String(payload.pointSystemId);
        ContentType.all()
          .toModelArray()
          .filter((item) => String(item.pointSistemId) === targetPointSystemId)
          .forEach((item) => item.delete());
        payload.items.forEach((item) => {
          ContentType.upsert(item);
        });
        break;
      }
      case ActionTypes.CONTENT_TYPE_CREATE__SUCCESS:
      case ActionTypes.CONTENT_TYPE_UPDATE__SUCCESS:
      case ActionTypes.CONTENT_TYPE_DELETE__SUCCESS:
        ContentType.upsert(payload.item);
        break;
      case ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS: {
        const targetPointSystemId = String(payload.pointSystemId);
        ContentType.all()
          .toModelArray()
          .filter((item) => String(item.pointSistemId) === targetPointSystemId)
          .forEach((item) => item.delete());
        (payload.contentTypes || []).forEach((item) => {
          ContentType.upsert(item);
        });
        break;
      }
      default:
    }
  }
}
